import React from "react";
import "./Certificate_Banner.css";

const Certificate_Banner = () => {
  return (
    <section className="Certificate_Banner">
      <div className="container">
        <div className="certificate_content_div">
          <div className="banner_left_div">
            <img
              src="/assets/images/claim_certificate/person-img.png"
              alt="left-img"
              className="left_img"
            />
          </div>

          <div className="banner_right_div">
            <h5 className="banner_title">Measure Your Skills</h5>
            <h5 className="banner_title">Unlock Your Next Step</h5>

            <p className="banner_text">
              Complete this short skill test to identify your strengths &
              improvement areas. Based on your performance, we’ll guide you
              toward the right program.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certificate_Banner;
